import { NewMessageToast, NewMessageToastProps } from '../../components/NewMessageToast';
import { QuickReplies } from './QuickReplies';
import { CANNED_MESSAGES } from './constants';

export function NewWaitingRoomMessageToast({
  senderName,
  messageContent,
  onOpenChatDrawer,
  onSend,
  ...toastAriaProps
}: NewMessageToastProps & {
  onSend: (message: string) => void;
}) {
  return (
    <NewMessageToast
      senderName={senderName}
      messageContent={messageContent}
      onOpenChatDrawer={onOpenChatDrawer}
      quickRepliesComponent={<QuickReplies cannedMessages={CANNED_MESSAGES} onSend={onSend} />}
      {...toastAriaProps}
    />
  );
}
